export enum DistanceUnitSystem {
  Imperial = 'Imperial',
  Metric = 'Metric',
}
